import { useFetch } from "../useFetch";
import { UseFetchProps, UseFetchReturn } from "../types";

type UseGetOptions<T> = Pick<UseFetchProps<T>, "serializer" | "skipAuth" | "url">;

export function useGet<T>(options: UseGetOptions<T>): UseFetchReturn<T> {
  return useFetch<T>({
    method: "GET",
    ...options,
  });
}
